import React from "react";
import { Button, dialog } from "nq-component";
import CardView from "../../../../components/common/CardView";
import InputFactory from "../../../../components/InputFactory";
import BasePage from "../../../../base/BasePage";
import attach from "../../../../components/common/attachment.jpg";
import SaveImageUseCase from "../../../../usecases/file/SaveImageUseCase";
import { upsertUseCase } from "../../../../usecases/object";
import {
  FloatingForm,
  SubmitImg,
} from "../../../../components/common/Converter";

export default class LibraryForm extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      selectedFiles: [],
      dragging: false,
      objectID: "",
      getUser: "",
    };
  }

  componentDidMount() {
    const { object } = this.props;
    if (Object.keys(object).length > 0) {
      console.log("LIBRARY OBJECTS", object);
      this.setState({
        name: object.name,
        selectedFiles: object.attachment,
        objectID: object.id,
        getUser: object.user,
      });
    }
  }

  handleNameChange(name) {
    this.setState({ name });
  }

  handleFileChange(event) {
    const files = Array.from(event.target.files);
    this.setState((prevState) => ({
      selectedFiles: [...prevState.selectedFiles, ...files],
    }));
  }

  handleRemoveFile(index) {
    this.setState((prevState) => {
      const selectedFile = prevState.selectedFiles.filter(
        (_, i) => i !== index
      );
      return { selectedFiles: selectedFile };
    });
  }

  handleDragOver(event) {
    event.preventDefault();
    this.setState({ dragging: true });
  }

  handleDragLeave() {
    this.setState({ dragging: false });
  }

  handleDrop(event) {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    this.setState((prevState) => ({
      selectedFiles: [...prevState.selectedFiles, ...files],
      dragging: false,
    }));
  }

  dialogClose() {
    dialog.close();
  }

  async confirmChanges() {
    const { name, selectedFiles, objectID } = this.state;
    const user = this.getCurrentUser().username;

    const imageResult = await SubmitImg(selectedFiles);

    console.warn("updateFILE: ", imageResult);

    if (objectID !== "") {
      const newData = {
        user: this.state.getUser,
        name: name,
        file: imageResult.length.toString(),
        attachment: imageResult,
        id: objectID,
      };
      console.warn("Library: ", newData);
      upsertUseCase().execute("library", newData);
      this.dialogClose();
      this.props.closeCollection();
      this.showSuccess("You have successfully uploaded new library !");
      this.props.refetchData();
    } else {
      const data = {
        user,
        name: name,
        file: imageResult.length.toString(),
        attachment: imageResult,
      };
      console.warn("Library: ", data);
      upsertUseCase().execute("library", data);
      this.dialogClose();
      this.props.closeCollection();
      this.showSuccess("You have successfully uploaded new library !");
      this.props.refetchData();
    }
  }

  handleClickOk() {
    if (this.state.selectedFiles.length < 1) {
      this.showError("Attachment Required");
      return;
    }
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>New Library Confirmation</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Click confirm to proceed.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={this.dialogClose.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={this.confirmChanges.bind(this)}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  render() {
    const { dragging, selectedFiles } = this.state;
    // console.warn("FILE: ", selectedFiles);
    selectedFiles?.map((file) => console.warn("test: ", typeof file));
    const dragAndDropStyle = {
      border: dragging ? "2px dashed #000" : "2px dashed #ccc",
      padding: "1rem",
      borderRadius: "4px",
      textAlign: "center",
      margin: "1rem 0",
      position: "relative",
      cursor: "pointer",
    };

    return (
      <>
        <FloatingForm width="50rem">
          <CardView style={{ padding: 0 }}>
            <h4 className="fs-6 fw-bold pt-3 ps-3">Details</h4>
            <hr />
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.handleClickOk();
              }}
            >
              <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                <div className="pb-4">
                  <label className="mb-2">
                    Name <span className="text-danger">*</span>
                  </label>

                  <InputFactory
                    required
                    type="String"
                    field="name"
                    onChange={this.handleNameChange.bind(this)}
                    value={this.state.name}
                  />
                </div>

                <div className="col-lg-12">
                  <label className="mb-2">
                    Attachments <span className="text-danger">*</span>
                  </label>
                  <div
                    style={dragAndDropStyle}
                    onDragOver={this.handleDragOver.bind(this)}
                    onDragLeave={this.handleDragLeave.bind(this)}
                    onDrop={this.handleDrop.bind(this)}
                  >
                    <div className="row" style={{ fontSize: "15px" }}>
                      <img
                        style={{
                          margin: "auto",
                          height: "5rem",
                          width: "5rem",
                          padding: 0,
                        }}
                        src={attach}
                        alt="attachment"
                      />
                      <span className="m-0 p-0">
                        Drag and drop files here or click to upload
                      </span>
                      <span className="m-0 p-0 text-black-50">
                        Support for a single or bulk upload. Strictly forhibit
                        from uploading company data or other band file.
                      </span>
                    </div>
                    <input
                      type="file"
                      multiple
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        opacity: 0,
                        cursor: "pointer",
                      }}
                      onChange={this.handleFileChange.bind(this)}
                    />
                  </div>
                  <div>
                    {selectedFiles?.map((file, index) => {
                      console.warn("FILE:", file);
                      const name =
                        typeof file === "string" ? file.split("_") : file.name;
                      return (
                        <div
                          key={index}
                          className="text-danger d-flex justify-content-center align-items-center mb-2"
                        >
                          {this.state.objectID !== "" ? (
                            typeof file === "string" ? (
                              <a href={file} target="_blank" rel="noreferrer">
                                {name[1] || file}
                              </a>
                            ) : (
                              name || file
                            )
                          ) : (
                            name || file
                          )}{" "}
                          <i
                            className="bi bi-trash ms-auto"
                            onClick={() => this.handleRemoveFile(index)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <hr />
              <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                <Button
                  className="btn btn-light fs-sm"
                  onClick={() => this.props.closeCollection()}
                  type="button"
                >
                  Cancel
                </Button>
                <Button className="btn btn-primary" type="submit">
                  Upload
                </Button>
              </div>
            </form>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
